import { Controller } from "@hotwired/stimulus";

// Both call sites live inside #current-card, which give_update_card_controller.js replaces
// wholesale after a logo or image change. The data-action bindings (webkitAnimationEnd/
// oanimationend/msAnimationEnd/animationend, one call site per browser-prefix family) are
// re-established by Stimulus itself on every reconnect, which a one-shot document-ready listener
// would not be.
//
// Nothing fires these events today: `.lt-initial-anim` has no live CSS `animation` rule reachable
// from this page. If one is added, it will be a genuine browser event that data-action sees just
// as a manually-attached listener would.
export default class extends Controller {
  static get classes() {
    return ["initial"];
  }

  connect() {
    this.element.classList.add(this.hasInitialClass ? this.initialClass : "lt-initial-anim");
  }

  onAnimationEnd() {
    this.element.classList.remove(this.hasInitialClass ? this.initialClass : "lt-initial-anim");
  }
}
